var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.99996 0.666504C2.77496 0.666504 0.166626 3.27484 0.166626 6.49984C0.166626 10.8748 5.99996 17.3332 5.99996 17.3332C5.99996 17.3332 11.8333 10.8748 11.8333 6.49984C11.8333 3.27484 9.22496 0.666504 5.99996 0.666504ZM5.99996 8.58317C4.84996 8.58317 3.91663 7.64984 3.91663 6.49984C3.91663 5.34984 4.84996 4.4165 5.99996 4.4165C7.14996 4.4165 8.08329 5.34984 8.08329 6.49984C8.08329 7.64984 7.14996 8.58317 5.99996 8.58317Z","fill":"#D6E1EF"}));
}

Location.defaultProps = {"width":"12","height":"18","viewBox":"0 0 12 18","fill":"none"};

module.exports = Location;

Location.default = Location;
